import React, { useEffect, useMemo, useState } from "react";
import { Header, Wrapper, CardWrapper } from "./style";
import Button from "../../../components/FormElement/Button";
import { PlusOutlined } from "@ant-design/icons";
import Spinner from "../../../components/Spinner/FullScreen";
import Form from "./Form";
import NewsCard from "../../../components/Cards/NewsCard";
import Pagination from "../../../components/FormElement/Pagination";
import service from "../../../services/news";
import DeleteModal from "../../../components/DeleteModal";
import { useShowAlert } from "../../../hooks/useAlerts";
import { useHideModal, useShowModal } from "../../../hooks";

function News() {
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);

  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : " "),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}`,
    [pageQuery, limitQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result.rows.map((item) => ({
        ...item,
        img: item?.media,
      }));
      setData(finalResult);
      setTotal(result.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [query]);
  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };
  const handleDelete = (id) => {
    if (id) {
      showBlured({
        title: "",
        maxWidth: "400px",
        maxHeight: "500px",
        withHeader: false,
        body: () => <DeleteModal onClick={() => handleDel(id)} />,
      });
    }
  };
  const handleDel = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleShowModal = () => {
    showBlured({
      title: "Ma'lumotlarni kiriting",
      maxWidth: "450px",
      maxHeight: "70vh",
      withHeader: false,
      body: () => <Form fetch={fetchData} />,
    });
  };

  const handleUpdate = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "450px",
      maxHeight: "684px",
      withHeader: false,
      body: () => <Form fetch={fetchData} id={data?.id} />,
    });
  };

  if (loading) return <Spinner />;
  return (
    <Wrapper>
      <Header>
        <Button
          icon={<PlusOutlined />}
          text="Qo'shish"
          onClick={handleShowModal}
        />
      </Header>
      <CardWrapper>
        {data.map((item) => {
          return (
            <NewsCard
              key={item.id}
              data={item}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
            />
          );
        })}
      </CardWrapper>

      {total > 10 && (
        <Pagination
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </Wrapper>
  );
}

export default News;
